import React from 'react';
import {
  Avatar,
  Box,
  Chip,
  Fade,
  Grid,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { DAYS_OF_WEEK, inputStyle } from '../constants';

const StepHoraires = ({ formData, setFormData, onToggleJourOff }) => {
  return (
    <Fade in>
      <Stack spacing={3}>
        <Box>
          <Typography variant="body2" color="#A3AED0" mb={3}>
            Configurez les jours de fermeture et les tranches horaires de l'offre.
          </Typography>

          {/* --- SECTION HORAIRES (MATIN / APREM) --- */}
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Box sx={{ p: 2, borderRadius: '20px', bgcolor: '#F9FBFF', border: '1px solid #E2EBF6' }}>
                <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                  <Avatar sx={{ width: 28, height: 28, bgcolor: '#4318FF' }}>1</Avatar>
                  <Typography variant="subtitle2" fontWeight="800">
                    Plage du Matin
                  </Typography>
                </Stack>
                <Stack spacing={2}>
                  <TextField
                    fullWidth
                    type="time"
                    label="Début"
                    InputLabelProps={{ shrink: true }}
                    value={formData.plage_horaire_matin_debut}
                    onChange={(e) =>
                      setFormData({ ...formData, plage_horaire_matin_debut: e.target.value })
                    }
                    sx={inputStyle}
                  />
                  <TextField
                    fullWidth
                    type="time"
                    label="Fin"
                    InputLabelProps={{ shrink: true }}
                    value={formData.plage_horaire_matin_fin}
                    onChange={(e) =>
                      setFormData({ ...formData, plage_horaire_matin_fin: e.target.value })
                    }
                    sx={inputStyle}
                  />
                </Stack>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box sx={{ p: 2, borderRadius: '20px', bgcolor: '#F9FBFF', border: '1px solid #E2EBF6' }}>
                <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                  <Avatar sx={{ width: 28, height: 28, bgcolor: '#4318FF' }}>2</Avatar>
                  <Typography variant="subtitle2" fontWeight="800">
                    Plage Après-midi
                  </Typography>
                </Stack>
                <Stack spacing={2}>
                  <TextField
                    fullWidth
                    type="time"
                    label="Début"
                    InputLabelProps={{ shrink: true }}
                    value={formData.plage_horaire_aprem_debut}
                    onChange={(e) =>
                      setFormData({ ...formData, plage_horaire_aprem_debut: e.target.value })
                    }
                    sx={inputStyle}
                  />
                  <TextField
                    fullWidth
                    type="time"
                    label="Fin"
                    InputLabelProps={{ shrink: true }}
                    value={formData.plage_horaire_aprem_fin}
                    onChange={(e) =>
                      setFormData({ ...formData, plage_horaire_aprem_fin: e.target.value })
                    }
                    sx={inputStyle}
                  />
                </Stack>
              </Box>
            </Grid>
          </Grid>

          {/* --- SECTION PAUSE --- */}
          <Box sx={{ mt: 3 }}>
            <TextField
              fullWidth
              type="number"
              label="Temps de pause (Entre chaque séance)"
              value={formData.duree_pause}
              onChange={(e) => setFormData({ ...formData, duree_pause: e.target.value })}
              InputProps={{
                endAdornment: <InputAdornment position="end">minutes</InputAdornment>,
              }}
              sx={inputStyle}
            />
          </Box>

          {/* --- SECTION JOURS DE REPOS --- */}
          <Box sx={{ p: 2.5, mt: 3, borderRadius: '20px', border: '1px solid #E2EBF6', bgcolor: '#FFF' }}>
            <Typography variant="subtitle2" fontWeight="800" color="#1B2559" mb={2}>
              Jours de repos (Sélectionnez les jours fermés)
            </Typography>

            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap gap={1.5}>
              {DAYS_OF_WEEK.map((day) => {
                const isSelected = formData.jours_off.includes(day);

                return (
                  <Chip
                    key={day}
                    label={day.charAt(0).toUpperCase() + day.slice(1)}
                    onClick={() => onToggleJourOff(day)}
                    icon={isSelected ? <CloseIcon sx={{ fontSize: 16, color: '#FFF' }} /> : null}
                    sx={{
                      borderRadius: '12px',
                      fontWeight: '700',
                      px: 1,
                      py: 2.5,
                      bgcolor: isSelected ? '#FF5B5B' : '#F4F7FE',
                      color: isSelected ? '#FFF' : '#A3AED0',
                      border: isSelected ? 'none' : '1px solid #E2EBF6',
                      '&:hover': { bgcolor: isSelected ? '#FF4444' : '#E2EBF6' },
                    }}
                  />
                );
              })}
            </Stack>
          </Box>
        </Box>
      </Stack>
    </Fade>
  );
};

export default StepHoraires;
